if (!customElements.get('umg-campaign-slideshow')) {
  customElements.define('umg-campaign-slideshow', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.slides = Array.from(this.querySelectorAll('[data-campaign-slide]'));
      if (this.slides.length < 2) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.index = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
      this.dots = Array.from(this.querySelectorAll('[data-campaign-dot]'));
      this.status = this.querySelector('[data-campaign-status]');
      this.pauseButton = this.querySelector('[data-campaign-pause]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.hovered = false;
      this.focused = this.contains(document.activeElement);
      this.userPaused = false;
      this.editorPaused = false;
      this.querySelector('[data-campaign-controls]').hidden = false;

      this.querySelector('[data-campaign-previous]').addEventListener('click', () => this.show(this.index - 1, true), options);
      this.querySelector('[data-campaign-next]').addEventListener('click', () => this.show(this.index + 1, true), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true), options));
      this.addEventListener('keydown', event => {
        if (!event.target.closest('[data-campaign-controls]')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => {
        this.focused = this.contains(event.relatedTarget);
        this.schedule();
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      if (this.pauseButton) {
        this.pauseButton.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.schedule();
        }, options);
      }

      const artwork = this.querySelector('.umg-campaign-slides');
      artwork.addEventListener('pointerdown', event => {
        this.suppressClickUntil = 0;
        this.gesture = event.pointerType === 'touch' ? { x: event.clientX, y: event.clientY } : null;
        this.schedule();
      }, options);
      artwork.addEventListener('pointerup', event => {
        if (!this.gesture) return;
        const x = event.clientX - this.gesture.x;
        const y = event.clientY - this.gesture.y;
        this.gesture = null;
        if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y) * 1.5) {
          this.suppressClickUntil = performance.now() + 750;
          this.show(this.index + (x < 0 ? 1 : -1), true);
        } else {
          this.schedule();
        }
      }, options);
      artwork.addEventListener('click', event => {
        if (performance.now() >= (this.suppressClickUntil || 0)) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClickUntil = 0;
      }, { ...options, capture: true });
      artwork.addEventListener('pointercancel', () => {
        this.gesture = null;
        this.schedule();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const selected = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (selected < 0) return;
        this.editorPaused = true;
        this.show(selected, false);
      }, options);
      document.addEventListener('shopify:block:deselect', event => {
        if (!this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) return;
        this.editorPaused = false;
        this.schedule();
      }, options);
      this.show(this.index, false);
    }

    show(index, announce) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== this.index; });
      this.dots.forEach((dot, dotIndex) => {
        if (dotIndex === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (announce && this.status) this.status.textContent = this.dataset.statusTemplate.replace('__NUMBER__', String(this.index + 1));
      this.schedule();
    }

    schedule() {
      window.clearTimeout(this.timer);
      if (this.pauseButton) {
        this.pauseButton.hidden = this.motion.matches;
        this.pauseButton.setAttribute('aria-pressed', String(this.userPaused));
        const label = this.userPaused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
        this.pauseButton.setAttribute('aria-label', label);
        this.pauseButton.querySelector('[data-campaign-playback-text]').textContent = this.userPaused ? this.pauseButton.dataset.playText : this.pauseButton.dataset.pauseText;
      }
      if (this.dataset.autoplay !== 'true' || this.userPaused || this.hovered || this.focused || this.gesture || this.editorPaused || document.hidden || this.motion.matches) return;
      const interval = Math.max(3000, Number(this.dataset.interval) || 7000);
      this.timer = window.setTimeout(() => this.show(this.index + 1, false), interval);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      if (this.events) this.events.abort();
      this.events = null;
    }
  });
}
